<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout justify-center row>
    <v-flex xs2>
      <SimpleCard>
        <RatingSearchBox @search="search" @clear="clear" :query="query"></RatingSearchBox>
      </SimpleCard>
    </v-flex>
    <v-flex xs10 pl-2>
      <SimpleCard>
        <v-layout row wrap align-content-center justify-center>
          <v-flex v-if="loading" xs12 pa-2 class="text-xs-center">
            <v-progress-circular :size="48" :width="5" color="primary" indeterminate></v-progress-circular>
          </v-flex>
          <RatingSummaryList
            v-if="!loading"
            style="width: 100%;"
            :ratings="ratings"
            :paginationProp="pagination"
          ></RatingSummaryList>
          <v-flex v-if="!loading" pt-2 xs9 class="text-xs-center pt-2">
            <v-pagination @input="changePage" v-model="pagination.page" :length="num_pages"></v-pagination>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import RatingSummaryList from "@/components/rating/RatingSummaryList.vue";
import RatingSearchBox from "@/components/rating/RatingsSearchBox.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import moment from "moment";

export default {
  name: "ratings",
  components: {
    SimpleCard,
    RatingSummaryList,
    RatingSearchBox
  },

  data: function() {
    return {
      ratings: [],
      offset: 0,
      count: 20,
      query: {
        rating: 0,
        driverID: null,
        customerID: null,
        customerToDriver: true
      },
      loading: true,
      pagination: { page: 1 },
      num_pages: 0,
      rideTypes: []
    };
  },
  mounted: async function() {
    if (this.$route.query.driver_id) {
      this.query.driverID = this.$route.query.driver_id;
    }

    if (this.$route.query.customer_id) {
      this.query.customerID = this.$route.query.customer_id;
    }

    this.getRatings();
  },
  methods: {
    search: function() {
      this.pagination.page = 1;
      this.getRatings();
    },
    clear: function() {
      this.query = {
        rating: 5,
        driverID: null,
        customerID: null,
        customerToDriver: true
      };
    },
    changePage: function(page) {
      this.pagination.page = page;
      console.log(page);
      this.getRatings();
    },
    getRatings: async function() {
      this.loading = true;

      try {
        var url = `${this.$store.state.apiUrl}/review/all?offset=${this.count *
          (this.pagination.page - 1)}&count=${this.count}`;

        if (this.query.rating != 0) {
          url += `&rating=${this.query.rating}`;
        }

        if (this.query.driverID != null) {
          url += `&driverID=${this.query.driverID}`;
        } else if (this.$route.query.driverID) {
          url += `&driverID=${this.$route.query.driverID}`;
        }

        if (this.query.customerID != null) {
          url += `&customerID=${this.query.customerID}`;
        }

        if (!this.query.customerToDriver) {
          url += `&reviewType=driver_to_customer`;
        } else {
          url += `&reviewType=customer_to_driver`;
        }

        let response = await axios.get(url, {
          params: {}
        });

        var ratings = response.data.reviews;

        this.ratings = ratings;

        console.log("Got ratings");
        console.log(this.ratings);

        this.pagination.page = response.data.pages.page;
        this.num_pages = response.data.pages.num_pages;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ratings " + error);
      }
    },
    failed: function(data) {
      alert("Request Failed with error: " + data.message);
    }
  }
};
</script>
